import React, { useEffect, useRef, useState } from "react";

export function InfoTooltip({ content }: { content: string }) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    function onPointerDown(e: PointerEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [open]);

  const visible = open || hovered;

  return (
    <span ref={containerRef} className="relative inline-block align-middle">
      <button
        type="button"
        aria-label="More information"
        aria-expanded={visible}
        onClick={() => setOpen((v) => !v)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-300 bg-white text-[10px] font-semibold leading-none text-slate-500 hover:border-program hover:text-program focus:outline-none focus:ring-2 focus:ring-program/40"
      >
        &#9432;
      </button>
      {visible && (
        <span
          role="tooltip"
          className="absolute left-0 top-full z-50 mt-1 block w-max max-w-xs rounded-md border border-slate-200 bg-white p-3 text-xs leading-relaxed text-slate-700 shadow-lg"
        >
          {content}
        </span>
      )}
    </span>
  );
}
